<style lang="css">
  .list-warp {
    padding:0.3rem
  }
</style>
<template>
  <div class="wzPage--home ">
    <div class="index-body ta-center">
      <div class="ta-center">
        <img v-if="isInMobile" src="../../assets/img/ad.png" width="100%" alt="">
        <img v-else src="../../assets/img/ad-pc.png" width="100%" alt="">
      </div>
      <div class="index-btnbox">
        <a href="javascript:;" class="btn-yellow btn-round btn-lg" @click="goDetail">立即解锁</a>
      </div>
      <div>
        <my-timer></my-timer>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters } from 'vuex'
  import { WZ } from '../../common/globals'
  import Timer from '../mod/timer'
  import { isInMobile } from '../../utils/base'
  export default {
    data() {
      return {
        isInMobile : isInMobile()
      }
    },
    components:{
      'my-timer' : Timer
    },
    computed: {
      ...mapState('config', ['endTime']),
      ...mapState('timer', ['_now']),
      ...mapGetters(['myUid','myGold']),
      ...mapState(['timeStatus','timeText']),
      
    },
    methods: {
      goDetail(){
        if(!this.myUid){
           WZ.go('login')
        } else {
          if(this._now<this.endTime){
            this.$router.push({name:'detail'})
          } else {
            this.$toast('活动已结束')
          }
          
        }
      }
    },
    created() {
      
    },
    watch:{
      
    }
  }
</script>
